(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-hero-desktop-full-width"] && !Shopify.designMode) return;
  try {
    
  /*
  const $legalTextPopup = document.querySelector('#header-legal-popup-');
  const $legalTextCTA = document.querySelector('#header-legal-cta-');
  const $legalTextBG = $legalTextPopup.querySelector('.legal-text__bg');
  const $legalTextCloseButtons = $legalTextPopup.querySelectorAll('button');

  const openLegalPopup = function() {
    $legalTextPopup.setAttribute('active', true);
    setTimeout(function() {
      $legalTextPopup.setAttribute('visible', true);
    }, 100);

    window.addEventListener('scroll', closeLegalPopup);
  };

  const closeLegalPopup = function() {
    $legalTextPopup.removeAttribute('visible');

    setTimeout(function() {
      $legalTextPopup.removeAttribute('active');
    }, 800);

    window.removeEventListener('scroll', closeLegalPopup);
  };

  $legalTextCTA.addEventListener('click', openLegalPopup);
  $legalTextBG.addEventListener('click', closeLegalPopup);

  $legalTextCloseButtons.forEach(function($btn) {
    $btn.addEventListener('click', closeLegalPopup);
  });

  // close legal text if Escape key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.key == 'Escape' && $legalTextPopup.hasAttribute('active')) {
      closeLegalPopup();
    }
  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-mobile-stacked"] && !Shopify.designMode) return;
  try {
    
  /*
  const $legalTextPopup = document.querySelector('#header-legal-popup-');
  const $legalTextCTA = document.querySelector('#header-legal-cta-');
  const $legalTextBG = $legalTextPopup.querySelector('.legal-text__bg');
  const $legalTextCloseButtons = $legalTextPopup.querySelectorAll('button');

  const openLegalPopup = function() {
    $legalTextPopup.setAttribute('active', true);
    setTimeout(function() {
      $legalTextPopup.setAttribute('visible', true);
    }, 100);

    window.addEventListener('scroll', closeLegalPopup);
  };

  const closeLegalPopup = function() {
    $legalTextPopup.removeAttribute('visible');

    setTimeout(function() {
      $legalTextPopup.removeAttribute('active');
    }, 800);

    window.removeEventListener('scroll', closeLegalPopup);
  };

  $legalTextCTA.addEventListener('click', openLegalPopup);
  $legalTextBG.addEventListener('click', closeLegalPopup);

  $legalTextCloseButtons.forEach(function($btn) {
    $btn.addEventListener('click', closeLegalPopup);
  });

  // close legal text if Escape key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.key == 'Escape' && $legalTextPopup.hasAttribute('active')) {
      closeLegalPopup();
    }
  });
  */

  } catch(e) { console.error(e); }
})();
})();
